import {FormattedMessage, IntlShape} from "react-intl";
import {formatCurrency} from "@feature/quotations/quotation-draft/lib/format";
import {MTColumnsType} from "@utils/pagination";
import {QuotationDraftSchema, QuotationDraftStatus, QuotationSchema, QuotationUser} from "@feature/quotations";
import Badge from "@ui-components/Badge";
import {EnvelopeIcon} from "@heroicons/react/24/outline";
import {Tooltip} from "react-tippy";

const getDraftStatusBadgeType = (status: QuotationDraftStatus) => {
  switch (status) {
    case 'latest': return 'info';
    case 'accepted': return 'success';
    case 'rejected': return 'error';
    case 'sent': return 'warning';
    case 'deprecated':
    default:
      return 'neutral';
  }
}

const getCreatorRole = (id_creator: number, quotation: QuotationSchema): QuotationUser | undefined => {
  if (quotation.id_agent === id_creator)
    return 'agent';
  if (quotation.id_resale === id_creator)
    return 'resale';
  // Might have been created by an admin
  return undefined;
}

export const getColumns = (
  intl: IntlShape,
  quotation: QuotationSchema,
): MTColumnsType<QuotationDraftSchema> => [
  {
    title: "",
    field: "number",
    render: ({number}) => `#${number}`,
    width: 10,
  },
  {
    title: intl.formatMessage({ id: 'created_at', defaultMessage: 'Data di creazione' }),
    field: 'created_at',
    type: 'datetime',
    render: ({created_at}) => Intl.DateTimeFormat(
      'it-IT',
      {dateStyle: 'short', timeStyle: 'short'}
    ).format(Date.parse(created_at)),
  },
  {
    title: intl.formatMessage({ id: 'des_creator', defaultMessage: 'Creato da' }),
    field: 'des_creator',
    render: ({id_creator, des_creator}) => {
      const role = getCreatorRole(id_creator, quotation);
      return (
        <div className="flex flex-col">
          <p className="font-semibold">{des_creator}</p>
          {!!role && <p className="text-xs"><FormattedMessage id={role} /></p>}
        </div>
      )
    },
  },
  {
    title: intl.formatMessage({ id: 'status', defaultMessage: 'Stato' }),
    field: 'status',
    render: ({status, notes}) => (
      <div className="flex flex-row gap-2 items-center">
        <Badge
          type={getDraftStatusBadgeType(status)}
          text={intl.formatMessage({id: `quotation_draft_status_${status}`})}
          onClick={undefined}
          textSize="text-xs"
        />
        {!!notes && <>
          <span>+</span>
          <Tooltip title={notes} arrow>
            <EnvelopeIcon className="w-5" />
          </Tooltip>
        </>}
      </div>
    )
  },
  {
    title: intl.formatMessage({ id: 'val_total', defaultMessage: 'Valore totale' }),
    field: 'val_total',
    render: (rowData) => formatCurrency(rowData.val_total),
  }
];